export enum UrlParams {
  RedirectUrl = 'redirectUrl',
  RedirectRoleKey = 'redirectRoleKey',
  Endpoint = 'endpoint',
  PageTitle = 'pageTitle',
}
